<template>
	<div class="col-12">
		<div class="card card-outline card-info">
			<div class="card-header">
				<h3 class="card-title">Mi equipo</h3>
				<div class="card-tools">
                    <div class="text-right">
                        <!-- Removed buttons as requested -->
                    </div>
				</div>
			</div>
			<div class="card-body">
				<!-- Filters Section -->
				<div class="row mb-3">
					<div class="col-md-6 mb-2">
						<label>Buscar:</label>
						<input type="text" class="form-control" v-model="search" @keyup="list()" placeholder="Nombre, correo, teléfono..." />
					</div>
					<!-- <div class="col-md-3 mb-2">
						<label>Área:</label>
						<select class="form-control" v-model="filters.area_id" @change="list()">
							<option value="">Todas</option>
							<option v-for="area in areas" :key="area.id" :value="area.id">
								{{ area.name }}
							</option>
						</select>
					</div> -->
					<div class="col-md-3 mb-2">
						<label>Perfil:</label>
						<select class="form-control" v-model="filters.profile_id" @change="list()">
							<option value="">Todos</option>
							<option v-for="profile in profiles" :key="profile.id" :value="profile.id">
								{{ profile.name }}
							</option>
						</select>
					</div>
					<div class="col-md-3 mb-2">
						<label>Estatus:</label>
						<select class="form-control" v-model="filters.status_id" @change="list()">
							<option value="">Todos</option>
							<option v-for="status in statuses" :key="status.id" :value="status.id">
								{{ status.name }}
							</option>
						</select>
					</div>
				</div>

				<!-- Results Info -->
				<div class="row mb-2" v-if="users.total">
					<div class="col-12">
						<small class="text-muted">
							Mostrando {{ users.from }} - {{ users.to }} de {{ users.total }} usuarios
						</small>
					</div>
				</div>

				<!-- Table -->
				<div class="table-responsive">
					<table class="table table-hover table-bordered user-table">
						<thead class="thead-light">
							<tr>
								<th class="text-center" style="width: 100px;">No. Empleado</th>
								<th style="width: 250px;">Nombre</th>
								<th class="text-center" style="width: 180px;">Área</th>
								<th class="text-center" style="width: 180px;">Perfil</th>
								<th class="text-center" style="width: 140px;">Teléfono</th>
								<th class="text-center" style="width: 100px;">Estatus</th>
								<th class="text-center" style="width: 120px;">Fecha Ingreso</th>
								<th class="text-center" style="width: 120px;">Opciones</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td colspan="8" class="text-center p-5">
									<i class="fas fa-spinner fa-pulse fa-3x text-primary"></i>
									<h6 class="mt-3 text-muted">Cargando usuarios...</h6>
								</td>
							</tr>
						</tbody>
						<tbody v-else-if="users && users.data && users.data.length">
							<tr v-for="(user, index) in users.data" :key="index" class="user-row">
								<td class="text-center align-middle">
									<span class="badge badge-light border employee-badge">
										{{ user.no_employee || 'N/A' }}
									</span>
								</td>
								<td class="align-middle">
								<div class="user-name hint--top hint--rounded" :aria-label="user.name + (user.last_name ? ' ' + user.last_name : '')">{{ user.name.split(' ')[0]+ ' '+ user.last_name.split(' ')[0] }}</div>
								<div class="user-email">{{ user.email }}</div>
							</td>
								<td class="text-center align-middle">
									<span v-if="user.area" class="area-name">
										{{ user.area.name }}
									</span>
									<span v-else class="text-muted">-</span>
								</td>
								<td class="text-center align-middle">
									<span v-if="user.profile" class="profile-name">{{ user.profile.name }}</span>
									<span v-else class="text-muted">Sin perfil</span>
								</td>
								<td class="text-center align-middle">
									<span v-if="user.phone" class="phone-number">
										{{ user.phone }}
									</span>
									<span v-else class="text-muted">-</span>
								</td>
								<td class="text-center align-middle">
									<span v-if="user.status" :class="getStatusBadgeClass(user.status.id)" class="status-badge">
										{{ user.status.name }}
									</span>
									<span v-else class="badge badge-secondary">N/A</span>
								</td>
								<td class="text-center align-middle">
									<span v-if="user.admission_date" class="date-text">
										{{ formatDate(user.admission_date) }}
									</span>
									<span v-else class="text-muted">-</span>
								</td>
								<td class="text-center align-middle">
									<div class="btn-group" role="group">
										<router-link :to="`/users/form/${user.id}`" v-can="'edit_users'" class="btn btn-outline-primary btn-sm" title="Editar">
											<i class="fas fa-edit"></i>
										</router-link>
										<button type="button" @click="deleted(user.id)" v-can="'deleted_users'" class="btn btn-outline-danger btn-sm" title="Eliminar">
											<i class="fa fa-trash"></i>
										</button>
									</div>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="8" class="p-5">
									<i class="fas fa-inbox fa-3x text-muted mb-3"></i>
									<h6 class="text-muted">No se encontraron resultados.</h6>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination v-if="users && users.total" v-model="page" :records="users.total" :per-page="users.per_page" @paginate="list" />                       			
			</div>
		</div>
	</div>
</template>

<script>
import {  mapMutations, mapActions } from 'vuex';
import Pagination from 'vue-pagination-2';
import request from '@/services/request'

export default {
	name: "my-team-table",
	components: {
		Pagination
	},
	data() {
		return {
            page:1,
			users: {},
			search: '',
            load: false,
			filters: {
				area_id: '',
				profile_id: '',
				status_id: ''
			},
			areas: [],
			profiles: [],
			statuses: []
		}
	},
	mounted() {
		this.list();
		this.setHeaderTitle('Mi equipo');
		this.loadCatalogues();
	},
	created() {
			Event.$on("event-load-users", () => {
					this.list();
			});
	},
	methods: {
		deleted: function (id) {
			let tit = 'Eliminar usuario';
			let txt = 'Seguro que quiere eliminar al usuario';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeleted(id);
				}
			});
		},
		async callDeleted(id) {
			let _endpoint = '/users/' + id;
			try {
				let response = await request.destroy(_endpoint).then(function (response) { return response;});
				this.list();
				this.successNotification(response.data.message);			
			} catch (error) {
				this.errors = await this.errorNotification(error)
			}
		},
		async list(page = 1) {
            this.load = true;
			let service = request;
			let search = this.search;
			let _endpoint = '/catalogue/related_users';
			
			// Build query params
			let params = {
				page: page,
				_search: search,
				area_id: this.filters.area_id,
				profile_id: this.filters.profile_id,
				status_id: this.filters.status_id
			};
			
			try {
				let { data } = await service.list(_endpoint, page, search, params)
				if (data) {
                    this.load = false;
					this.users = data;
				}
			} catch (error) {
				this.load = false;
				console.log(error);
			}
		},
		async loadCatalogues() {
			try {
				// Load areas
				const areasResponse = await request.get('/catalogue/areas');
				this.areas = areasResponse.data;

				// Load profiles - using profiles_list for simple Profile models
				const profilesResponse = await request.get('/catalogue/profiles_list');
				this.profiles = profilesResponse.data;

				// Load statuses
				const statusesResponse = await request.get('/catalogue/statuses');
				this.statuses = statusesResponse.data;
			} catch (error) {
				console.error('Error loading catalogues:', error);
			}
		},
		formatDate(date) {
			if (!date) return '-';
			const d = new Date(date);
			const day = String(d.getDate()).padStart(2, '0');
			const month = String(d.getMonth() + 1).padStart(2, '0');
			const year = d.getFullYear();
			return `${day}/${month}/${year}`;
		},
		getStatusBadgeClass(statusId) {
			// Assuming status 1 is Active, adjust based on your actual data
			if (statusId === 1) {
				return 'badge badge-success';
			} else {
				return 'badge badge-danger';
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		})
	}
}
</script>

<style scoped>
.pagination {
	margin-bottom: 0;
}

.user-table {
	font-size: 0.85rem;
}

.user-table thead th {
	background-color: #f8f9fa;
	border-bottom: 2px solid #dee2e6;
	font-weight: 600;
	text-transform: uppercase;
	font-size: 0.7rem;
	letter-spacing: 0.3px;
	padding: 12px 10px;
	vertical-align: middle;
	white-space: nowrap;
}

.user-table tbody td {
	padding: 12px 10px;
	vertical-align: middle;
}

.user-row {
	transition: background-color 0.2s ease;
}

.user-row:hover {
	background-color: #f8f9fa;
}

/* Employee Badge */
.employee-badge {
	padding: 0.35em 0.7em;
	font-size: 0.8rem;
	font-weight: 600;
	color: #495057;
}

/* User Name and Email */
.user-name {
	font-weight: 600;
	font-size: 0.875rem;
	color: #212529;
	margin-bottom: 3px;
}

.user-email {
	font-size: 0.75rem;
	color: #6c757d;
}

/* Area Name */
.area-name {
	color: #007bff;
	font-weight: 600;
	font-size: 0.85rem;
}

/* Profile Name */
.profile-name {
	color: #495057;
	font-size: 0.85rem;
}

/* Phone Number */
.phone-number {
	color: #495057;
	font-size: 0.8rem;
}

/* Status Badge */
.status-badge {
	padding: 0.3em 0.7em;
	font-size: 0.75rem;
	font-weight: 600;
	border-radius: 0.25rem;
}

/* Date Text */
.date-text {
	color: #495057;
	font-size: 0.8rem;
}

.btn-group .btn {
	padding: 0.3rem 0.5rem;
	font-size: 0.8rem;
}

.table-responsive {
	border-radius: 0.25rem;
}

label {
	margin-bottom: 0.25rem;
	font-size: 0.85rem;
	font-weight: 500;
}

.form-control {
	font-size: 0.85rem;
	padding: 0.4rem 0.6rem;
}

/* Filter section spacing */
.mb-3 {
	margin-bottom: 1rem !important;
}

.mb-2 {
	margin-bottom: 0.75rem !important;
}
</style>
